import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  input,
  select {
    flex: auto;
  }
  span,
  div {
    flex: none;
  }
`
